import { useState, useEffect, useMemo } from "react";
import {
  Typography,
  useDataGrid,
  DataGrid,
  List,
  CreateButton,
} from "@pankod/refine-mui";
import useLocales from "locales/useLocales";
import { itIT } from "@mui/x-data-grid";

export default function CustomList({
  title,
  columns,
  resource,
  canCreate,
  metas,
  dataGridParams = null,
  customDataGetter = null,
}) {
  // default settings
  const { currentLang, defaultLang } = useLocales();
  const columsMemo = useMemo(() => columns, []);

  // load custom parameters if there is a getter function ---------------------
  const [loading, setLoading] = useState(true);
  const [customData, setCustomData] = useState(null);

  const loadCustomData = async () => {
    if (customDataGetter == undefined) {
      setLoading(false);
      return;
    }
    const data = await customDataGetter();
    setCustomData(data);
    setLoading(false);
  };

  useEffect(() => {
    loadCustomData();
  }, [customDataGetter]);
  // -------------------------------------------------------------------------

  // check for custom parameters
  const isFunction = (functionToCheck) => {
    return (
      functionToCheck &&
      {}.toString.call(functionToCheck) === "[object Function]"
    );
  };

  const params = isFunction(dataGridParams)
    ? dataGridParams(customData)
    : dataGridParams;

  //build datagrid
  const { dataGridProps, sortingMode, sortModel, onSortModelChange } =
    useDataGrid({
      resource: resource,
      /*metaData: {
        locale: currentLang.value || defaultLang,
        populate: "*",
        ...metas,
      },*/
      metaData: {
        locale: defaultLang,
        populate: "deep,2",
        fakeParam: currentLang.value, //this is to force re-fetching data when language changes
        ...metas,
      },
      ...params,
    });

  // bail out if loading
  if (loading)
    return (
      <List
        resource={resource}
        createButtonProps={{ size: "small" }}
        canCreate={canCreate}
        title={<Typography variant="h5">{title}</Typography>}
      >
        <div>Loading...</div>
      </List>
    );

  //render
  return (
    <List
      resource={resource}
      createButtonProps={{ size: "small" }}
      headerButtons={canCreate ? <CreateButton>Nuovo</CreateButton> : null}
      canCreate={canCreate}
      title={<Typography variant="h5">{title}</Typography>}
    >
      <DataGrid
        {...dataGridProps}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columsMemo}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        autoHeight
      />
    </List>
  );
}
